import { Box, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AppShell from '../components/layout/AppShell';
import DesignSystem from '../designSystem';
import { type ApiBusiness } from '../services/api';
import { useNewsUpdates } from '../contexts/NewsUpdatesContext';
import { useT } from '../i18n/useT';

export default function NotificationsListPage() {
  const t = useT();
  const navigate = useNavigate();
  const { newsItems, loading, error } = useNewsUpdates();

  const openBusiness = (b: unknown) => {
    const bus = b as ApiBusiness;
    const u = bus.username?.replace('@', '') || String(bus.id);
    if (u) navigate(`/${u}`);
  };

  return (
    <AppShell title={t('notificationsUpdatesTitle')} showBackButton maxWidth="feed" showCompanion>
      {loading && (
        <Typography sx={{ color: DesignSystem.colors.textSecondary, py: 4, textAlign: 'center' }}>
          {t('homeUpdatesLoading')}
        </Typography>
      )}
      {error && <Alert severity="error">{error}</Alert>}
      {!loading && !error && newsItems.length === 0 && (
        <Box sx={{ py: 6, textAlign: 'center' }}>
          <Typography sx={{ fontWeight: 600, mb: 0.75, color: DesignSystem.colors.textPrimary }}>
            {t('homeUpdatesEmptyTitle')}
          </Typography>
          <Typography sx={{ fontSize: 14, color: DesignSystem.colors.textSecondary }}>
            {t('notificationsEmptyListBody')}
          </Typography>
        </Box>
      )}
      {newsItems.map((n, i) => {
        const b = n.business as ApiBusiness | undefined;
        const msg = typeof n.message === 'string' ? n.message : t('notificationFallback');
        const time = typeof n.time === 'string' ? n.time : '';
        return (
          <Box
            key={`${i}-${msg}`}
            onClick={() => b && openBusiness(b)}
            sx={{
              py: 1.5,
              px: 0.5,
              borderBottom: `1px solid ${DesignSystem.colors.separator}`,
              cursor: b ? 'pointer' : 'default',
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 15, color: DesignSystem.colors.textPrimary }}>
              {msg}
            </Typography>
            {time && (
              <Typography sx={{ fontSize: 13, color: DesignSystem.colors.textSecondary, mt: 0.25 }}>
                {time}
              </Typography>
            )}
          </Box>
        );
      })}
    </AppShell>
  );
}
